import React, {Component} from 'react';
import PropTypes from 'prop-types';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import CountrySelector from '../CountrySelector/CountrySelector';

class CountryLanguageSelector extends Component {

    static propTypes = {
        countries: PropTypes.arrayOf(
            PropTypes.shape({
                countryCode: PropTypes.string,
                countryName: PropTypes.string,
                siteUrl: PropTypes.string,
                languages: PropTypes.arrayOf(
                    PropTypes.shape({
                        languageCode: PropTypes.string,
                        languageName: PropTypes.string
                    })
                )
            })
        ),
        languages: PropTypes.arrayOf(
            PropTypes.shape({
                languageCode: PropTypes.string,
                languageName: PropTypes.string
            })
        ),
        translations: PropTypes.shape({
            chooseCountry: PropTypes.string,
            chooseLanguage: PropTypes.string
        }),
        countryCode: PropTypes.string,
        languageCode: PropTypes.string,
        handleCountrySelectorChange: PropTypes.func,
        handleLanguageSelectorChange: PropTypes.func,
        languageSelectorOnly: PropTypes.bool
    }

    static defaultProps = {
        countries: [{countryCode: 'jp', countryName: '日本'}, {countryCode: 'us', countryName: 'United States'}],
        languages: [],
        translations: {
            chooseCountry: 'Country',
            chooseLanguage: 'Language'
        },
        countryCode: 'us',
        languageCode: 'en',
        handleCountrySelectorChange: () => {},
        handleLanguageSelectorChange: () => {}
    }

    /* istanbul ignore next */
    constructor(props) {
        super(props);
    }

    render() {
        const {translations, countries, languages, countryCode, languageCode, handleCountrySelectorChange, handleLanguageSelectorChange} = this.props;
        let languageSelectorOnly = this.props.languageSelectorOnly || this.props.countries.length === 1;

        return (
           <div>
               {!languageSelectorOnly &&
               <CountrySelector
                   title={translations.chooseCountry}
                   countryCode={countryCode}
                   countries={countries}
                   onChange={handleCountrySelectorChange}
               />}
               <LanguageSelector
                   title={translations.chooseLanguage}
                   languageCode={languageCode}
                   languages={languages}
                   onChange={handleLanguageSelectorChange}
               />
           </div>
        );
    }

}

export default CountryLanguageSelector;
